export const BeeCrewYellow = {
  50: '#FFF8E2',
  100: '#FEECB4',
  200: '#FDE085',
  300: '#FDD554',
  400: '#FDCA31',
  500: '#FCC11C',
  600: '#FCB316',
  700: '#FCA113',
  800: '#FB9012',
  900: '#FA710F',
}

// Backup
// export const BeeCrewYellowDark = {
//   50: '#FEEDC4',
//   100: '#FEE2A1',
//   200: '#FED879',
//   300: '#FDCD5E',
//   400: '#FCC54F',
//   500: '#FCBB4B',
//   600: '#FCAE47',
//   700: '#FCA247',
//   800: '#FB8A44',
//   900: '#E47D3E',
// }

export const BeeCrewYellowDark = {
  50: '#FEEDC4',
  100: '#FDD488',
  200: '#FDC86A',
  300: '#FCBB4B',
  400: '#EFAA3E',
  500: '#E19831',
  600: '#D48624',
  700: '#C67417',
  800: '#A15D0F',
  900: '#7F4502',
}

export const BeeCrewGrey = {
  50: '#F3F3F4',
  100: '#DDDDDE',
  200: '#C6C6C8',
  300: '#B0B0B3',
  400: '#9B9B9E',
  500: '#868689',
  600: '#727275',
  700: '#5E5E61',
  800: '#4B4B4B',
  850: '#3A3A3A',
  900: '#252526',
  950: '#1B1B1B',
}

export const AccentBlue = {
  50: '#DDE6FF',
  100: '#B7CAFA',
  200: '#87ABFA',
  300: '#6F8EFC',
  400: '#5860FC',
  500: '#464EEB',
  600: '#343CD9',
  700: '#222AC8',
  800: '#1018B6',
  900: '#0F16A5',
}

export const AccentBlueDark = {
  50: '#9CB3EE',
  100: '#8DA0E9',
  200: '#7E8CE6',
  300: '#6E78E2',
  400: '#5E65DF',
  500: '#575FCB',
  600: '#575FBC',
  700: '#4F5695',
  800: '#373F58',
  900: '#282937',
}

export const AccentPurple = {
  50: '#F1EEFF',
  100: '#DCD3FF',
  200: '#CFB7FD',
  300: '#C19BFB',
  400: '#B474F7',
  500: '#A94DF2',
  600: '#9D26ED',
  700: '#8B1DD7',
  800: '#7813C0',
  900: '#670AA9',
}

export const AccentPurpleDark = {
  50: '#E1BAEE',
  100: '#D7A7E7',
  200: '#CE94E0',
  300: '#C482D9',
  400: '#BB6FD2',
  500: '#A762BC',
  600: '#9157A3',
  700: '#7F4C8F',
  800: '#673D75',
  900: '#4E2C58',
}

export const AccentTeal = {
  50: '#E3F8FF',
  100: '#B0E4F3',
  200: '#9BDBED',
  300: '#86D2E7',
  400: '#5BC0DB',
  500: '#50B2CC',
  600: '#45A3BC',
  700: '#2E869D',
  800: '#17697E',
  900: '#004B5F',
}

export const AccentTealDark = {
  50: '#86DEF3',
  100: '#66C6DD',
  200: '#56BAD2',
  300: '#46ADC7',
  400: '#44A2BA',
  500: '#4197AD',
  600: '#3F8CA0',
  700: '#3C8193',
  800: '#376B79',
  900: '#1E373F',
}

export const AccentGreen = {
  50: '#E4FFD8',
  100: '#C6F3B2',
  200: '#AEDF98',
  300: '#96CB7E',
  400: '#78AE5F',
  500: '#59913F',
  600: '#4A8330',
  700: '#3A7420',
  800: '#2A6110',
  900: '#194E00',
  950: '#5a7c4b'
}

export const AccentGreenDark = {
  50: '#B2D5A2',
  100: '#96BF84',
  200: '#88B475',
  300: '#7AA965',
  400: '#749F60',
  500: '#6D945B',
  600: '#5F7E51',
  700: '#516947',
  800: '#43533C',
  900: '#273422',
}

export const AccentOrange = {
  50: '#FFEBD8',
  100: '#FFE0B8',
  200: '#FFC885',
  300: '#FFBC6B',
  400: '#FFA553',
  500: '#F19549',
  600: '#E2853F',
  700: '#C4652A',
  800: '#A64515',
  900: '#882500',
  950: '#e06b00'
}

export const AccentOrangeDark = {
  50: '#FAC18E',
  100: '#F2AC6E',
  200: '#E99449',
  300: '#E08739',
  400: '#C5732B',
  500: '#B2692A',
  600: '#A86429',
  700: '#895325',
  800: '#6E4521',
  900: '#442713',
}

export const TypographyLight = {
  50: '#9E9E9E',
  100: '#666666',
  200: '#363636',
  300: '#212121',
  //   400: '#',
  //   500: '#',
  //   600: '#',
  //   700: '#',
  //   800: '#',
  //   900: '#',
}

export const TypographyDark = {
  50: '#CDCDCD',
  100: '#C5C5C5',
  200: '#AEAEAE',
  300: '#929293',
  400: '#717172',
  //   500: '#',
  //   600: '#',
  //   700: '#',
  //   800: '#',
  //   900: '#',
}

export const ElevationLight = {
  50: '#FFFFFF',
  100: '#F2F2F2',
  200: '#EDEDED',
  300: '#E8E8E8',
  400: '#E3E3E3',
  500: '#DEDEDE',
  600: '#D9D9D9',
  700: '#D4D4D4',
  800: '#CFCFCF',
  900: '#C9C9C9',
}

export const ElevationDark = {
  50: '#1B1B1B',
  100: '#252526',
  200: '#303031',
  300: '#343435',
  400: '#39393A',
  500: '#3D3D3E',
  600: '#414142',
  700: '#464647',
  800: '#4A4A4B',
  900: '#4E4E4F',
}

// For future additions
// export const template = {
//   50: '#',
//   100: '#',
//   200: '#',
//   300: '#',
//   400: '#',
//   500: '#',
//   600: '#',
//   700: '#',
//   800: '#',
//   900: '#',
// }
